"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevicePrint = void 0;
var react_1 = __importStar(require("react"));
var constants_1 = require("../constants");
var DevicePrint = function (_a) {
    var track = _a.track;
    (0, react_1.useEffect)(function () {
        var start = Date.now();
        try {
            window.adx.initiate({
                onInitialize: function () {
                    // hdim - hdmJavascriptData
                    track === null || track === void 0 ? void 0 : track(constants_1.TrackingEvent.t12r41pInitSuccess, {
                        initializeDuration: Date.now() - start,
                    });
                },
                /* istanbul ignore next */
                onValidate: function () {
                    // javascriptData
                    /* istanbul ignore next */
                    track === null || track === void 0 ? void 0 : track(constants_1.TrackingEvent.t12r41pValidateSuccess, {
                        validateDuration: Date.now() - start,
                    });
                },
                /* istanbul ignore next */
                onInitializeTimeout: function () {
                    /* istanbul ignore next */
                    track === null || track === void 0 ? void 0 : track(constants_1.TrackingEvent.t12r41pInitTimeout, {
                        initializeTimeoutDuration: Date.now() - start,
                    });
                },
                /* istanbul ignore next */
                onResourceTimeout: function () {
                    /* istanbul ignore next */
                    track === null || track === void 0 ? void 0 : track(constants_1.TrackingEvent.t12r41pInitResourceTimeout, {
                        resourceTimeoutDuration: Date.now() - start,
                    });
                },
                timeout: 30000, // 30s timeout instead of the 2s default, which is causing problems on slower connections
            });
        }
        catch (error) {
            track === null || track === void 0 ? void 0 : track(constants_1.TrackingEvent.t12r41pInitFailure);
            console.error("41P initiate method failed: ", error);
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { "data-testid": "41p-device-print", hidden: true, id: constants_1.DEVICE_PRINT_USER_PREFS_ID }),
        react_1.default.createElement("input", { "data-testid": "41p-device-print2", hidden: true, id: constants_1.DEVICE_PRINT_USER_PREFS2_ID })));
};
exports.DevicePrint = DevicePrint;
//# sourceMappingURL=DevicePrint.js.map